<template>
  <router-link :to="{ name: 'AddNewPost' }">
    <div class="add-post-btn">
      <q-btn round color="lale-primary" icon="fal fa-plus" size="20px" />
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'AddPostBtn'
};
</script>

<style scoped lang="scss">
@import '@/styles/quasar.variables';
.add-post-btn {
  position: fixed;
  right: 15px;
  bottom: 50px;
  z-index: 999;
}

// Lale app IOS 需推高
.in-laleIos-app .add-post-btn {
  bottom: 135px;
}

// 從相簿進入推高
.pushiOS {
  .add-post-btn {
    bottom: 100px
  }
}
</style>
